// src/pages/auth/Register.js
// Page d'inscription - NE PAS MODIFIER

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const Register = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      padding: '16px',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '24px',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
    },
    logoSection: { textAlign: 'center', marginBottom: '24px' },
    logoTitle: { fontSize: '28px', fontWeight: '700', color: '#FFD700' },
    logoSubtitle: { fontSize: '13px', color: '#A0AEC0', marginTop: '4px' },
    form: { display: 'flex', flexDirection: 'column', gap: '14px' },
    field: { display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#A0AEC0' },
    input: {
      padding: '14px 16px',
      backgroundColor: '#111827',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      color: '#FFFFFF',
      fontSize: '15px',
      outline: 'none',
    },
    button: {
      padding: '16px',
      backgroundColor: '#FFD700',
      border: 'none',
      borderRadius: '10px',
      color: '#0A0E1A',
      fontSize: '16px',
      fontWeight: '700',
      cursor: 'pointer',
      marginTop: '8px',
    },
    links: {
      display: 'flex',
      justifyContent: 'center',
      gap: '6px',
      marginTop: '20px',
    },
    link: { color: '#FFD700', fontSize: '14px', cursor: 'pointer' },
    text: { color: '#A0AEC0', fontSize: '14px' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Inscription | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/')}>←</button>
      </div>

      <div style={styles.logoSection}>
        <div style={styles.logoTitle}>Fynho</div>
        <div style={styles.logoSubtitle}>Créez votre compte</div>
      </div>

      <div style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>Nom complet</label>
          <input
            type="text"
            style={styles.input}
            value={formData.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Jean Kamga"
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Email</label>
          <input
            type="email"
            style={styles.input}
            value={formData.email}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="votre@email.com"
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Téléphone</label>
          <input
            type="tel"
            style={styles.input}
            value={formData.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            placeholder="+237 6XX XXX XXX"
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Mot de passe</label>
          <input
            type="password"
            style={styles.input}
            value={formData.password}
            onChange={(e) => handleChange('password', e.target.value)}
            placeholder="••••••••"
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Confirmer le mot de passe</label>
          <input
            type="password"
            style={styles.input}
            value={formData.confirmPassword}
            onChange={(e) => handleChange('confirmPassword', e.target.value)}
            placeholder="••••••••"
          />
        </div>
        <button style={styles.button} onClick={() => navigate('/')}>
          S'inscrire
        </button>
      </div>

      <div style={styles.links}>
        <span style={styles.text}>Déjà un compte ?</span>
        <span style={styles.link} onClick={() => navigate('/login')}>
          Se connecter
        </span>
      </div>
    </div>
  );
};

export default Register;